import { pgaComTld } from "../components/utils"

export const PTM_LEGACY_APPLICATION_PATHS = [
  "/applications/associate",
  "/applications/affiliate",
  "/applications/associate/edit",
  "/applications/affiliate/edit",
]

export const MEMBER_APPLICATIONS_URL = `https://${pgaComTld}/member/account/applications`

export const shouldSuppressPtmLegacyApplicationRoute = path =>
  PTM_LEGACY_APPLICATION_PATHS.includes(path)

/**
 * Legacy Member application routes. Unlike the Associate/Affiliate paths above
 * these stay real routes unless the `applications-membership` flag is on, in
 * which case `Routes.js` redirects them to the hub. `/applications/success`
 * and `/applications/error` are the legacy forms' post-submit pages.
 *
 * Cleanup: when the redirect becomes unconditional, drop the flag branch in
 * `Routes.js`, then remove these paths from `RouteConfig.js` together with
 * `src/components/Applications`.
 */
export const MEMBER_LEGACY_APPLICATION_PATHS = [
  "/applications/membership",
  "/applications/membership/edit",
  "/applications/success",
  "/applications/error",
]

export const isMemberLegacyApplicationPath = path =>
  MEMBER_LEGACY_APPLICATION_PATHS.includes(path)

export const redirectToMemberApplications = () => {
  window.location.href = MEMBER_APPLICATIONS_URL
}
